import { v4 as uuidv4 } from 'uuid';
// TODO: replace this redundancy with 'the createUuid()' from 'utils/uuid.ts'
export const createUuid = () => uuidv4();
